/* tslint:disable */
/* eslint-disable */

/**
 * 0 = Base
 * 1 = Alerte
 * 2 = Article
 * 3 = ArticleStock
 * 4 = Calendrier
 * 5 = CategorieDocument
 * 6 = CodePostal
 * 7 = Commande
 * 8 = Compteur
 * 9 = Conteneur
 * 10 = Cotisations
 * 11 = DemandeEvacuation
 * 12 = DemandeTransport
 * 13 = Destination
 * 14 = DestinationEvacuation
 * 15 = DispatchExutoire
 * 16 = DispatchTransporteur
 * 17 = Document
 * 18 = ElementNettoyage
 * 19 = Emplacement
 * 20 = Exutoire
 * 21 = FicheControle
 * 22 = FormeJuridique
 * 23 = Incident
 * 24 = Intervention
 * 25 = JokerPP
 * 26 = Menu
 * 27 = Nettoyage
 * 28 = NumeroSpecial
 * 29 = Parametre
 * 30 = Pays
 * 31 = Permission
 * 32 = PersonneMorale
 * 33 = PersonnePhysique
 * 34 = Pictogramme
 * 35 = PlanningEvacuation
 * 36 = PlaquesPM
 * 37 = PlaquePP
 * 38 = RapportManager
 * 39 = RapportPrepose
 * 40 = Recyparc
 * 41 = Role
 * 42 = SecondeResidence
 * 43 = Theme
 * 44 = Transporteur
 * 45 = TypeAccesPM
 * 46 = TypeConteneur
 * 47 = TypeControle
 * 48 = TypeDechets
 * 49 = TypeDechetsRW
 * 50 = TypeEvacuation
 * 51 = TypeIncident
 * 52 = TypeIntervention
 * 53 = TypeReparation
 * 54 = UniteMesure
 * 55 = Utilisateur
 * 56 = Visite
 * 57 = ZoneGeographique
 * 58 = PhotoPda
 * 59 = TypeElementStock
 * 60 = EtatStock
 * 61 = RapportIncident
 */
export enum PermissionPrefix {
  Base = 0,
  Alerte = 1,
  Article = 2,
  ArticleStock = 3,
  Calendrier = 4,
  CategorieDocument = 5,
  CodePostal = 6,
  Commande = 7,
  Compteur = 8,
  Conteneur = 9,
  Cotisations = 10,
  DemandeEvacuation = 11,
  DemandeTransport = 12,
  Destination = 13,
  DestinationEvacuation = 14,
  DispatchExutoire = 15,
  DispatchTransporteur = 16,
  Document = 17,
  ElementNettoyage = 18,
  Emplacement = 19,
  Exutoire = 20,
  FicheControle = 21,
  FormeJuridique = 22,
  Incident = 23,
  Intervention = 24,
  JokerPP = 25,
  Menu = 26,
  Nettoyage = 27,
  NumeroSpecial = 28,
  Parametre = 29,
  Pays = 30,
  Permission = 31,
  PersonneMorale = 32,
  PersonnePhysique = 33,
  Pictogramme = 34,
  PlanningEvacuation = 35,
  PlaquesPM = 36,
  PlaquePP = 37,
  RapportManager = 38,
  RapportPrepose = 39,
  Recyparc = 40,
  Role = 41,
  SecondeResidence = 42,
  Theme = 43,
  Transporteur = 44,
  TypeAccesPM = 45,
  TypeConteneur = 46,
  TypeControle = 47,
  TypeDechets = 48,
  TypeDechetsRW = 49,
  TypeEvacuation = 50,
  TypeIncident = 51,
  TypeIntervention = 52,
  TypeReparation = 53,
  UniteMesure = 54,
  Utilisateur = 55,
  Visite = 56,
  ZoneGeographique = 57,
  PhotoPda = 58,
  TypeElementStock = 59,
  EtatStock = 60,
  RapportIncident = 61
}
